var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M10.229,14.67a.881.881,0,0,0,0,1.222l4.2,4.271a.834.834,0,0,0,1.167.027l4.137-4.208a.876.876,0,0,0,0-1.222.835.835,0,0,0-1.2,0l-3.554,3.572-3.558-3.667a.835.835,0,0,0-1.2,0Z",
    transform: "translate(-9.983 -14.415)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowDownLight.5d266ae4086d08d0f33dc24b5ba271ce.svg";